export default __webpack_public_path__ + "static/media/4-2_image02@2x.22808857.png";